// Shared Kids Academy category taxonomy — used by the Landing page's kids
// section, the Kids Academy page, and the footer's Kids Academy links.
// Deliberately NOT part of the general `/categories` backend collection
// (which powers the main /courses browse sidebar) — kids categories are a
// separate, frontend-defined taxonomy matched against the `kids-*` course
// category prefix the admin course form offers.
export const KIDS_CATEGORIES = [
  { id: "kids-coding",      name: "Coding",         icon: "Code2",        color: "#722F37", desc: "Scratch, Python & block coding" },
  { id: "kids-robotics",    name: "Robotics",        icon: "CircuitBoard", color: "#2C497F", desc: "Build and program real robots" },
  { id: "kids-mathematics", name: "Mathematics",     icon: "Calculator",   color: "#2E5A44", desc: "Fun numbers and problem solving" },
  { id: "kids-english",     name: "English",         icon: "Languages",    color: "#8B2635", desc: "Reading, writing, communication" },
  { id: "kids-science",     name: "Science",         icon: "FlaskConical", color: "#B8860B", desc: "Experiments and discovery" },
  { id: "kids-creative",    name: "Creative Arts",   icon: "Palette",      color: "#722F37", desc: "Drawing, design and creativity" },
];
